export const DigiCodeRev5TrackCircuit_Schema = [
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [{ title: "Reason for Adjustment", colSpan: 18, leftAlign: true, accessor: "ballast" }],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Track No. ", colSpan: 6, leftAlign: true, accessor: "track" },
      { title: "Channel", colSpan: 6, leftAlign: true, accessor: "channel" },
      { title: "Code", colSpan: 6, leftAlign: true, accessor: "code" },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [{ title: "Measured Values", colSpan: 18, leftAlign: false, isTitleOnly: true }],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "V.RX ", colSpan: 6, rowSpan: 1, accessor: "vRX" },
      { title: "V.OUT ", colSpan: 6, rowSpan: 1, accessor: "vout" },
      { title: "VTX ", colSpan: 6, rowSpan: 1, accessor: "vtx" },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Transmitter End", colSpan: 6, rowSpan: 1, accessor: "transmitterEnd", isTitleOnly: true },
      { title: "Current (Irail)", colSpan: 6, rowSpan: 1, accessor: "tCurrent" },
      { title: "Voltage (Vrail)", colSpan: 6, rowSpan: 1, accessor: "tVoltage" },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Receiver-1", colSpan: 6, rowSpan: 1, accessor: "receiver1", isTitleOnly: true },
      { title: "Current (Irail)", colSpan: 6, rowSpan: 1, accessor: "r1Current" },
      { title: "Voltage (Vrail)", colSpan: 6, rowSpan: 1, accessor: "r1Voltage" },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Receiver-2", colSpan: 6, rowSpan: 1, accessor: "receiver2", isTitleOnly: true },
      { title: "Current (Irail)", colSpan: 6, rowSpan: 1, accessor: "r2Current" },
      { title: "Voltage (Vrail)", colSpan: 6, rowSpan: 1, accessor: "r2Voltage" },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [{ title: "", colSpan: 18, rowSpan: 1, accessor: "loc", isTitleOnly: true, disable: true }],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Shunt applied at TX end", colSpan: 9, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: "Shunt applied at receiver -1", colSpan: 9, rowSpan: 1, accessor: "requiress", isTitleOnly: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true, disable: true },
      { title: ".06Ω", colSpan: 3, rowSpan: 1, accessor: "requiress", isTitleOnly: true },
      { title: ".5Ω", colSpan: 3, rowSpan: 1, accessor: "requiress", isTitleOnly: true },
      { title: "", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true, disable: true },
      { title: ".06Ω", colSpan: 3, rowSpan: 1, accessor: "requiress", isTitleOnly: true },
      { title: ".5Ω", colSpan: 3, rowSpan: 1, accessor: "requiress", isTitleOnly: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "VRX- 1", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: ".06", colSpan: 3, rowSpan: 1, accessor: "shuntapplyVrx1", isValueOnly: true },
      { title: ".5Ω", colSpan: 3, rowSpan: 1, accessor: "shuntapplyR2Vrx1", isValueOnly: true },
      { title: "VRX- 1", colSpan: 3, rowSpan: 1, accessor: "shuntreceiv1R2R2", isTitleOnly: true },
      { title: ".06", colSpan: 3, rowSpan: 1, accessor: "shuntreceiv1R1Vrx1", isValueOnly: true },
      { title: ".5Ω", colSpan: 3, rowSpan: 1, accessor: "shuntreceiv1R2Vrx1", isValueOnly: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "VRX- 2", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: ".06", colSpan: 3, rowSpan: 1, accessor: "shuntapplyVrx2", isValueOnly: true },
      { title: ".5Ω", colSpan: 3, rowSpan: 1, accessor: "shuntapplyR2Vrx2", isValueOnly: true },
      { title: "VRX- 2", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: ".06", colSpan: 3, rowSpan: 1, accessor: "shuntreceiv1R1Vrx2", isValueOnly: true },
      { title: ".5Ω", colSpan: 3, rowSpan: 1, accessor: "shuntreceiv1R2Vrx2", isValueOnly: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Output LED-1", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: ".06", colSpan: 3, rowSpan: 1, accessor: "shuntapplyOL1", isValueOnly: true },
      { title: ".5Ω", colSpan: 3, rowSpan: 1, accessor: "shuntapplyR2OL1", isValueOnly: true },
      { title: "Output LED-1", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: ".06", colSpan: 3, rowSpan: 1, accessor: "shuntreceiv1R1OL1", isValueOnly: true },
      { title: ".5Ω", colSpan: 3, rowSpan: 1, accessor: "shuntreceiv1R2L1", isValueOnly: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Output LED-2", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: ".06", colSpan: 3, rowSpan: 1, accessor: "shuntapplyOL2", isValueOnly: true },
      { title: ".5Ω", colSpan: 3, rowSpan: 1, accessor: "shuntapplyR2OL2", isValueOnly: true },
      { title: "Output LED-2", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: ".06", colSpan: 3, rowSpan: 1, accessor: "shuntreceiv1R1OL2", isValueOnly: true },
      { title: ".5Ω", colSpan: 3, rowSpan: 1, accessor: "shuntreceiv1R2OL2", isValueOnly: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Adjacent TC status", colSpan: 9, rowSpan: 1, accessor: "adjacentTCstatus", leftAlign: true },
      { title: "Adjacent TC status", colSpan: 9, rowSpan: 1, accessor: "adjacentTCstatus2", leftAlign: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Shunt applied at receiver-2", colSpan: 9, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: "Shunt applied in the middle of main branch", colSpan: 9, rowSpan: 1, accessor: "requiress", isTitleOnly: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true, disable: true },
      { title: ".06Ω", colSpan: 3, rowSpan: 1, accessor: "requiress", isTitleOnly: true },
      { title: ".5Ω", colSpan: 3, rowSpan: 1, accessor: "requiress", isTitleOnly: true },
      { title: "", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true, disable: true },
      { title: ".06Ω", colSpan: 6, rowSpan: 1, accessor: "requiress", isTitleOnly: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "VRX- 1", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: ".06", colSpan: 3, rowSpan: 1, accessor: "shuntreceiv1R3Vrx1", isValueOnly: true },
      { title: ".5Ω", colSpan: 3, rowSpan: 1, accessor: "shuntreceiv1R4Vrx1", isValueOnly: true },
      { title: "VRX- 1", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: ".06", colSpan: 6, rowSpan: 1, accessor: "shuntmain1R5Vrx1", isValueOnly: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "VRX- 2", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: ".06", colSpan: 3, rowSpan: 1, accessor: "shuntreceiv1R3Vrx2", isValueOnly: true },
      { title: ".5Ω", colSpan: 3, rowSpan: 1, accessor: "shuntreceiv1R4Vrx2", isValueOnly: true },
      { title: "VRX- 2", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: ".06", colSpan: 6, rowSpan: 1, accessor: "shuntmain1R5Vrx2", isValueOnly: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Output LED-1", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: ".06", colSpan: 3, rowSpan: 1, accessor: "shuntreceiv1R3OL1", isValueOnly: true },
      { title: ".5Ω", colSpan: 3, rowSpan: 1, accessor: "shuntreceiv1R4L1", isValueOnly: true },
      { title: "Output LED-1", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: ".06", colSpan: 6, rowSpan: 1, accessor: "shuntmain1R5OL1", isValueOnly: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Output LED-2", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: ".06", colSpan: 3, rowSpan: 1, accessor: "shuntreceiv1R3OL2", isValueOnly: true },
      { title: ".5Ω", colSpan: 3, rowSpan: 1, accessor: "shuntreceiv1R4OL2", isValueOnly: true },
      { title: "Output LED-2", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: ".06", colSpan: 6, rowSpan: 1, accessor: "shuntmain1R5OL2", isValueOnly: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Adjacent TC status", colSpan: 9, rowSpan: 1, accessor: "adjacentTCstatus3", leftAlign: true },
      { title: "Adjacent TC status", colSpan: 9, rowSpan: 1, accessor: "loc", leftAlign: true, isValueOnly: true, disable: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [{ title: "Divider", colSpan: 18, rowSpan: 1, accessor: "loc", leftAlign: true, isValueOnly: true, disable: true }],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "VTX Adj", colSpan: 6, rowSpan: 1, accessor: "vTXAdj", leftAlign: true },
      { title: "VRX-1 Adj", colSpan: 6, rowSpan: 1, accessor: "vRXAdj1", leftAlign: true },
      { title: "VRX 2 Adj", colSpan: 6, rowSpan: 1, accessor: "vRXAdj2", leftAlign: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "P25 Jumper", colSpan: 9, rowSpan: 1, accessor: "p25Jumper", isTitleOnly: true },
      { title: "P1", colSpan: 3, rowSpan: 1, accessor: "p25JumperP1", leftAlign: true },
      { title: "P3", colSpan: 3, rowSpan: 1, accessor: "p25JumperP3", leftAlign: true },
      { title: "P5", colSpan: 3, rowSpan: 1, accessor: "p25JumperP5", leftAlign: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [{ title: "Track Condition", colSpan: 18, rowSpan: 1, accessor: "", isTitleOnly: true }],
  },
  {
    heights: { header1: "80px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [{ title: "Track Condition", colSpan: 18, rowSpan: 1, accessor: "trackCond", isValueOnly: true }],
  },
];



// WEBPACK FOOTER //
// ./src/components/Reports/PATH/TrackCircuitReport/DigicodeRev5TrackCircuit/DigiCodeRev5TrackCircuit_Schema.jsx